<template>
  <v-app>
    <v-main class="auth-page">
      <div class="topbar-auth">
        <a href="https://defittemedewerker.nl" target="_blank">
          <k-app-logo width="170"></k-app-logo>
        </a>
      </div>
      <div class="page-unavailable">
        <va-card class="card box-shadow-card" width="913">
          <v-row>
            <v-col cols="12" md="4" class="page-unavailable__art">
              <v-img :src="require('@/assets/img/404.svg')"></v-img>
            </v-col>
            <v-col cols="12" md="8" class="my-auto">
              <h1 class="display-4">
                {{ $t("components.pageUnavailable.title") }}
              </h1>
              <k-spacing y="4"></k-spacing>
              <p>{{ $t("components.pageUnavailable.text") }}</p>
              <k-spacing y="4"></k-spacing>
              <v-btn
                :href="account_login_url"
                color="var(--company-primary)"
                class="btn text-white"
              >
                {{ $t("ga-naar-inloggen") }}
              </v-btn>
            </v-col>
          </v-row>
        </va-card>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import config from "../config/index";

export default {
  computed: {
    // The account host, never the subdomain we are standing on: that
    // Bedrijfspagina is the thing that just failed to resolve, so its own login
    // screen would only send the user back into it. See docs/adr/0032.
    account_login_url() {
      return `${config.url.login.replace("{{domain}}", "inloggen")}/inloggen`;
    },
  },
};
</script>

<style scoped>
.page-unavailable {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 110px);
  padding: 24px 16px;
}

/* The illustration is decorative — never let it push the copy off the screen. */
@media (max-width: 768px) {
  /* Two classes, because Vuetify's own .v-col-12 max-width is one. */
  .page-unavailable .page-unavailable__art {
    max-width: 240px;
    margin: 0 auto;
  }
}

/* k-app-404 defines this globally, but only when that component is loaded. */
.page-unavailable .box-shadow-card {
  box-shadow: 0px 6px 24px 0px rgba(78, 78, 78, 0.08) !important;
}
</style>
